module.exports = __webpack_public_path__ + "static/assets/c5353140b7d13c3beceb811ad943bd20.svg";